<template>
   <div>
<!-- active-class="active-bc"
        exact-active-class="exct-active" 
        
        v-if="itemsBreadcrumbs !== null"
        -->

  <v-breadcrumbs :items="itemsBreadcrumbs"  class="px-xs-1 px-sm-0">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :to="item.href"
        :disabled="item.disabled"
        active-class="lastBc"        
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
   </div>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default {
  name: 'Breadcrumbs',
  data () {
    return {
        items: [],
      
    }
  },
    computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },      
          isMobile: {
      get () {
        return this.$store.state.app.isMobile
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setIsMobile', val)
      }
    }, 
      breadcrumbs () {
        let vApp = this;

        return vApp.$route.path;
      },
      itemsBreadcrumbs (){
        let vApp = this;
        if(DEBUG) console.log('breddd :', vApp.$store.state.breadcrumb.currBreadcrumb);
        return  vApp.$store.getters.getBreadcrumb;
      }

    },
  mounted () {    
    if(DEBUG) console.log('mounted Breadcumbs')
    let vApp = this
    this.$nextTick(function () {
      
      if(DEBUG) console.log('this.breadcrumbs :', vApp.breadcrumbs)
      if(DEBUG) console.log('this.itemsBreadcrumbs :', vApp.itemsBreadcrumbs)
    });
  }    
}
</script>
<style scope>
/* .v-application a.v-breadcrumbs__item.active-bc {
  color: rgb(195, 51, 51);
} */
.v-application a.v-breadcrumbs__item {
  color: #000;
  text-decoration: underline;
}
/* .lastBc{
  background-color: rgba(200, 221, 233, 0.4);
  padding: 3px;
} */
 .theme--light.v-breadcrumbs .lastBc .v-breadcrumbs__divider,  .theme--light.v-breadcrumbs .lastBc .v-breadcrumbs__item--disabled{
  color: rgb(95, 95, 95);
  
}

</style>